exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tr_loading {\n  height: 100%;\n  background: #E6EAF9;\n  text-align: center;\n  padding-top: 10%;\n}", "", {"version":3,"sources":["F:/workSpace/eclipse/branch/mcFroutendTemp/src/components/turn_page.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB","file":"turn_page.vue","sourcesContent":[".tr_loading {\n  height: 100%;\n  background: #E6EAF9;\n  text-align: center;\n  padding-top: 10%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b9d8e9e","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/turn_page.vue
// module id = SalO
// module chunks = 1